import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=5e881aa4&scoped=true"
import script from "./CatalogueList.vue?vue&type=script&lang=js"
export * from "./CatalogueList.vue?vue&type=script&lang=js"
import style0 from "./CatalogueList.vue?vue&type=style&index=0&id=5e881aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e881aa4",
  null
  
)

export default component.exports